import * as React from "react"
import { Col, Container, Row } from "react-grid-system"
import Card from "../../atoms/Card"
import Subtitle from "../../atoms/typography/Subtitle"
import { HorizontalSpacer } from "../../atoms/spacers"
import TextInput from "../../molecules/TextInput"
import SecondaryButton from "../../atoms/buttons/SecondaryButton"

import BodyLarge from "../../atoms/typography/BodyLarge"
import { Link } from "react-router-dom"

const PasswordResetDonePage: React.FC = () => {
  React.useEffect(() => {
    document.title = "Reset password"
  }, [])

  return (
    <div style={{ backgroundColor: "#D5E2EAe1", minHeight: "100vh" }}>
      <HorizontalSpacer spacing={6} />
      <Container>
        <Row justify="center">
          <Col md={3} xs={0} />
          <Col md={6} xs={12}>
            <Card>
              <HorizontalSpacer spacing={2} />
              <Row justify="center">
                <Subtitle>Password reset complete</Subtitle>
              </Row>
              <HorizontalSpacer spacing={4} />

              <Row justify="center">
                <Col>
                  <BodyLarge textAlign="center">Your password reset in now completed.</BodyLarge>
                </Col>
              </Row>

              <HorizontalSpacer spacing={3} />
              <Row justify="center">
                <Link to="/login">
                  <SecondaryButton title="Log in" />
                </Link>
              </Row>
              <HorizontalSpacer spacing={2} />
            </Card>
          </Col>
          <Col md={3} xs={0} />
        </Row>
      </Container>
      <HorizontalSpacer spacing={3} />
    </div>
  )
}

export default PasswordResetDonePage
